import './rate-entry-loading.css';

/** Shared visual handoff only: no borrower data or private provider imports. */
export function RateEntryLoading() {
  return <div className="rate-entry-loading" data-testid="rate-entry-loading">
    <section aria-label="Opening your options">
      <span>Lendwise <small>Mortgage</small></span>
      <p role="status">Opening your options…</p>
      <i aria-hidden="true" />
      <a href="/mortgage-rates">Back to rates</a>
    </section>
  </div>;
}
